import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import moment from 'moment'
import Modal from '../../../UniformComponents/Modal'
import Button from '../../../UniformComponents/Button'
import Date from '../../form/Date'

import './styles/settings.scss'

@observer
export default class ReOpenSurvey extends Component {
    constructor(props) {
        super(props)
        const { tz } = this.props
        this.state = {
            surveyCloseDate: this.roundToNext30Minutes(moment.tz(tz).add(1, 'weeks')),
        }
    }

    handleBlur = (obj) => {
        this.setState({ surveyCloseDate: obj.value })
    }

    handleConfirm = () => {
        const { onDateChange, onClose } = this.props
        const { surveyCloseDate } = this.state
        onDateChange({ value: surveyCloseDate, name: 'surveyCloseDate' })
        onClose()
    }

    isInTheFuture = ({ value }) => value.isAfter(moment())

    roundToNext30Minutes = (date) => {
        const minutes = date.minutes()
        const remainder = minutes % 30
        const addMinutes = remainder === 0 ? 0 : 30 - remainder
        return date.add(addMinutes, 'minutes').startOf('minute')
    };

    render() {
        const {
            show,
            onClose,
            cssClass,
            tz,
        } = this.props
        const { surveyCloseDate } = this.state
        return (
            <Modal
                show={show}
                onClose={onClose}
            >
                <div id="open-survey-modal" className={cssClass}>
                    <div className="uc-modal__header">
                        <h2>{i18n.t('settings_open_survey')}</h2>
                        <div>
                            <p className="uc-modal__desc">
                                {i18n.t('settings_open_survey_content')}
                            </p>
                        </div>
                    </div>
                    <div className="uc-modal__date-picker">
                        <Date
                            name="survey_closing_date"
                            label={i18n.t('survey_closing_date')}
                            value={surveyCloseDate.tz(tz)}
                            minDate={moment.tz(tz).add(1, 'days')}
                            emptyError={`${i18n.t('survey_closing_date')} ${i18n.t('required')}`}
                            onBlur={this.handleBlur}
                            isMandatory
                            allowManualDateEdit={false}
                            validate={this.isInTheFuture}
                            showTimeSelect
                            dateFormat="DD/MM/YYYY HH:mm z"
                            calendarCss="schedule-email-modal-picker"
                        />
                    </div>
                    <div className="uc-modal__button-panel">
                        <Button
                            onClick={onClose}
                            cssClass="tertiary"
                            label={i18n.t('close', 'Close')}
                        />
                        <Button
                            onClick={this.handleConfirm}
                            cssClass="primary"
                            label={i18n.t('settings_open_survey_confirm')}
                        />
                    </div>
                </div>
            </Modal>
        )
    }
}
